export const DETAILS_MODAL_ACTIONS = {
  FETCH_DETAILS_MODAL: 'PRODUCT_DETAILS:DETAILS_MODAL_ACTIONS:FETCH_DETAILS_MODAL',
  FETCH_DETAILS_MODAL_SUCCESS: 'PRODUCT_DETAILS:DETAILS_MODAL_ACTIONS:FETCH_DETAILS_MODAL_SUCCESS',
  FETCH_DETAILS_MODAL_ERROR: 'PRODUCT_DETAILS:DETAILS_MODAL_ACTIONS:FETCH_DETAILS_MODAL_ERROR',

  SET_DEVICE_IS_FAVORITE: 'PRODUCT_DETAILS:DETAILS_MODAL_ACTIONS:SET_DEVICE_IS_FAVORITE',
  SET_DEVICE_IS_CMP: 'PRODUCT_DETAILS:DETAILS_MODAL_ACTIONS:SET_DEVICE_IS_CMP',
  SET_DEVICE_IS_PURCHASE_LOADING:
    'PRODUCT_DETAILS:DETAILS_MODAL_ACTIONS:SET_DEVICE_IS_PURCHASE_LOADING',
};
